"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UNFAVOURITE_BOX_APP = "mutation unfavouriteBoxApp($appId: ID!) {\n  unfavouriteBoxApp(appId: $appId)\n}";
exports.default = UNFAVOURITE_BOX_APP;
//# sourceMappingURL=unfavouriteBoxApp.js.map